import React, { Fragment } from "react";
import styled from "styled-components";
import { BrandedNavBar } from "@nulogy/components";
import { useAuth0 } from "@auth0/auth0-react";

const MenuLink = styled.a(({ hoverColor, hoverBackground, theme }) => ({
  marginTop: "5px",
  fontWeight: theme.fontWeights.medium,
  transition: ".2s",
  "&:hover, &:focus": {
    outline: "none",
    color: theme.colors[hoverColor] || hoverColor,
    backgroundColor: theme.colors[hoverBackground] || hoverBackground,
    cursor: "pointer",
  },
  "&:disabled": {
    opacity: ".5",
  },
  "&:focus": {
    boxShadow: theme.shadows.focus,
  },
}));

const NavBar = () => {
  const { user, logout } = useAuth0();

  const logoutWithRedirect = () =>
    logout({
      returnTo: window.location.origin,
    });

  const renderProfile = () => {
    return (
      <Fragment>
        <div style={{ fontSize: "12pt" }}>{user.name}</div>
        <div style={{ fontSize: "12pt" }} className="lead text-muted">
          {user.email}
        </div>
      </Fragment>
    );
  };

  const renderImage = () => {
    return (
      <img
        src={user.picture}
        alt="Profile"
        className="nav-user-profile rounded-circle"
        width="50"
      />
    );
  };
  const renderLogout = () => {
    return <MenuLink onClick={() => logoutWithRedirect()}>Log Out </MenuLink>;
  };

  const primaryMenu = [];

  const secondaryMenu = [
    { name: "profile", render: renderProfile },
    { name: "profile-image", render: renderImage },
    { name: "log-out", render: renderLogout },
  ];

  return <BrandedNavBar menuData={{ primaryMenu, secondaryMenu }} />;
};

export default NavBar;
